import { InstallmentStatus, InvoiceStatus } from '#types';

export const canAddPaymentInstallment = (
	invoiceExists: boolean,
	status?: InvoiceStatus
) =>
	status
		? ![
			InvoiceStatus.Void,
			InvoiceStatus.Hidden,
			InvoiceStatus.Disputed,
		  ].includes( status )
		: !invoiceExists;

export const paymentInstallmentIsMutable = ( paymentInstallment?: {
	status?: InstallmentStatus | null;
} ) =>
	paymentInstallment?.status
		? paymentInstallment.status === InstallmentStatus.Unpaid
		: true;
